import { SnapshotSearchQaCitation } from "@/modules/snapshots/snapshotCollections/components/outcomes/search/types";

export const formatSnapshotQaWithLink = (text: string, citations: SnapshotSearchQaCitation[]) => {
  const referencePattern = /\[([A-Z0-9]+)\]/g;
  return text.replace(referencePattern, (_, referenceId) => {
    const citation = citations.find(c => c.snapshot_id === referenceId);
    return `[${citation?.document_name || referenceId}](/reports/outcome/${referenceId} '${citation?.explanation.replace(/'/g, "") || "View details"}')`;
  });
};
